import Vue from "vue";
import VueRouter from "vue-router";

import Default from "@layouts/Default";
import Light from "@layouts/Light";
import Field from "@layouts/Field";

const Dashboard = () => import(/* webpackChunkName: "main" */ "@pages/Dashboard")
const DashboardOrganization = () => import(/* webpackChunkName: "main" */ "@pages/DashboardOrganization")

const Login = () => import(/* webpackChunkName: "main" */ "@pages/Account/Login.vue")

const ForgotPassword = () => import(/* webpackChunkName: "main" */ "@pages/Account/ForgotPassword")
const ChangePassword = () => import(/* webpackChunkName: "main" */ "@pages/Account/ChangePassword")
const Activation = () => import(/* webpackChunkName: "main" */ "@pages/Account/Activation.vue")

const AccountForm = () => import(/* webpackChunkName: "main" */ "@pages/Account/AccountForm")


const Operators = () => import(/* webpackChunkName: "operators" */ "@pages/Operator/Operators")
const Operator = () => import(/* webpackChunkName: "operators" */ "@pages/Operator/Operator")


const UserSearch = () => import(/* webpackChunkName: "user" */ "@pages/User/UserSearch")
const UserForm = () => import(/* webpackChunkName: "user" */ "@pages/User/UserForm")

const Report = () => import(/* webpackChunkName: "report" */ "@pages/Report/Report")
const ReportUsages = () => import(/* webpackChunkName: "report" */ "@pages/Report/ReportUsages")

const ReportExports = () => import(/* webpackChunkName: "issue" */ "@pages/Report/ReportExports")
const ReportOffline = () => import(/* webpackChunkName: "report" */ "@pages/Report/ReportOffline")
const ReportEnergyProvider = () => import(/* webpackChunkName: "report" */ "@pages/Report/ReportEnergyProvider.vue")
const MailEventSearch = () => import(/* webpackChunkName: "report" */ "@pages/MailEvent/MailEventSearch.vue")

const Alerts = () => import(/* webpackChunkName: "alert" */ "@pages/Alert/Alerts")
const Issues = () => import(/* webpackChunkName: "issue" */ "@pages/Issue/Issues")
const IssueAdd = () => import(/* webpackChunkName: "issue" */ "@pages/Issue/IssueAdd")
const IssueDetail = () => import(/* webpackChunkName: "issue" */ "@pages/Issue/IssueDetail")

const ManageTariffs = () => import(/* webpackChunkName: "static" */ "@pages/Static/ManageTariffs.vue")
const ElectricityIndexSearch = () => import(/* webpackChunkName: "electricity-index" */ "@pages/ElectricityIndex/ElectricityIndexSearch.vue")
const ElectricityIndexForm = () => import(/* webpackChunkName: "electricity-index" */ "@pages/ElectricityIndex/ElectricityIndexForm.vue")
const ElectricityTariffSearch = () => import(/* webpackChunkName: "electricity-tariff" */ "@pages/ElectricityTariff/ElectricityTariffSearch.vue")
const ElectricityTariffForm = () => import(/* webpackChunkName: "electricity-tariff" */ "@pages/ElectricityTariff/ElectricityTariffForm.vue")
const PriceIndexSearch = () => import(/* webpackChunkName: "price-index" */ "@pages/PriceIndex/PriceIndexSearch.vue")
const PriceIndexForm = () => import(/* webpackChunkName: "price-index" */ "@pages/PriceIndex/PriceIndexForm.vue")
const PriceTariffSearch = () => import(/* webpackChunkName: "price-tariff" */ "@pages/PriceTariff/PriceTariffSearch.vue")
const PriceTariffForm = () => import(/* webpackChunkName: "price-tariff" */ "@pages/PriceTariff/PriceTariffForm.vue")
const OrganizationPerimeterSearch = () => import(/* webpackChunkName: "organization-perimeter" */ "@pages/Organization/Perimeter/PerimeterSearch.vue")
const OrganizationPerimeterForm = () => import(/* webpackChunkName: "organization-perimeter" */ "@pages/Organization/Perimeter/PerimeterForm.vue")
const OrganizationSubPerimeterForm = () => import(/* webpackChunkName: "organization-perimeter" */ "@pages/Organization/Perimeter/SubPerimeterForm.vue")
const OrganizationSubPerimeterSearch = () => import(/* webpackChunkName: "organization-perimeter" */ "@pages/Organization/Perimeter/SubPerimeterSearch.vue")


const TokenSearch = () => import(/* webpackChunkName: "subscription" */ "@pages/Token/TokenSearch.vue")

const SubscriptionPlanSearch = () => import(/* webpackChunkName: "subscription" */ "@pages/SubscriptionPlan/SubscriptionPlanSearch.vue")

const MemberRegisterIban = () => import(/* webpackChunkName: "main" */ "@pages/Iban/RegisterIban.vue")

const MemberInvitation = () => import(/* webpackChunkName: "main" */ "@pages/Member/Invitation.vue")
const ImportTariffs = () => import(/* webpackChunkName: "main" */ "@pages/Gireve/ImportTariffs.vue")

const ImportMeterDeviceCdr = () => import(/* webpackChunkName: "main" */ "@pages/MeterDevice/ImportMeterDeviceCdr.vue")
const MeterDeviceSearch = () => import(/* webpackChunkName: "price-index" */ "@pages/MeterDevice/MeterDeviceSearch.vue")

// Payment Onboarding
const EnrollmentList = () => import(/* webpackChunkName: "payment-onboarding" */ "@pages/PaymentOnboarding/EnrollmentList.vue")
const EnrollmentNew = () => import(/* webpackChunkName: "payment-onboarding" */ "@pages/PaymentOnboarding/EnrollmentNew.vue")
const EnrollmentImport = () => import(/* webpackChunkName: "payment-onboarding" */ "@pages/PaymentOnboarding/EnrollmentImport.vue")

// Module d'onboarding (nouveau) — distinct de Payment Onboarding, l'ancien enrôlement
const RegistrationList = () => import(/* webpackChunkName: "onboarding" */ "@pages/Onboarding/RegistrationList.vue")
const RegistrationDetail = () => import(/* webpackChunkName: "onboarding" */ "@pages/Onboarding/RegistrationDetail.vue")
const CommissioningList = () => import(/* webpackChunkName: "onboarding" */ "@pages/Onboarding/CommissioningList.vue")
const ConsentWithdrawals = () => import(/* webpackChunkName: "onboarding" */ "@pages/Onboarding/ConsentWithdrawals.vue")
const BadgeInventory = () => import(/* webpackChunkName: "badge-inventory" */ "@pages/BadgeInventory/BadgeInventory.vue")
const FirmwarePage = () => import(/* webpackChunkName: "firmware" */ "@pages/Firmware/FirmwarePage.vue")
const ManufacturerSheet = () => import(/* webpackChunkName: "manufacturer" */ "@pages/Manufacturer/ManufacturerSheet.vue")
const ManufacturersPage = () => import(/* webpackChunkName: "manufacturer" */ "@pages/Manufacturer/ManufacturersPage.vue")
const ManufacturerProductLines = () => import(/* webpackChunkName: "manufacturer" */ "@pages/Manufacturer/Sheet/ManufacturerProductLines.vue")
const ManufacturerFirmware = () => import(/* webpackChunkName: "manufacturer" */ "@pages/Manufacturer/Sheet/ManufacturerFirmware.vue")
const ManufacturerSettings = () => import(/* webpackChunkName: "manufacturer" */ "@pages/Manufacturer/Sheet/ManufacturerSettings.vue")
const ManufacturerHistory = () => import(/* webpackChunkName: "manufacturer" */ "@pages/Manufacturer/Sheet/ManufacturerHistory.vue")
const TrackedKeys = () => import(/* webpackChunkName: "charging-point-configuration" */ "@pages/ChargingPointConfiguration/TrackedKeys.vue")
const FirmwareLaunch = () => import(/* webpackChunkName: "firmware" */ "@pages/Firmware/FirmwareLaunch.vue")
const FirmwareEdit = () => import(/* webpackChunkName: "firmware" */ "@pages/Firmware/FirmwareEdit.vue")
const BadgeShipmentPreparation = () => import(/* webpackChunkName: "onboarding" */ "@pages/Onboarding/BadgeShipmentPreparation.vue")
const CommissioningDetail = () => import(/* webpackChunkName: "onboarding" */ "@pages/Onboarding/CommissioningDetail.vue")
// Le tunnel public est dans son propre paquet : une personne invitée ne télécharge pas le back-office.
const RegistrationTunnel = () => import(/* webpackChunkName: "onboarding-tunnel" */ "@pages/Onboarding/RegistrationTunnel.vue")
const JoinByLink = () => import(/* webpackChunkName: "onboarding-tunnel" */ "@pages/Onboarding/JoinByLink.vue")
const JoinConfirm = () => import(/* webpackChunkName: "onboarding-tunnel" */ "@pages/Onboarding/JoinConfirm.vue")
const FieldPortal = () => import(/* webpackChunkName: "field" */ "@pages/Onboarding/Field/FieldPortal.vue")
const FieldOrder = () => import(/* webpackChunkName: "field" */ "@pages/Onboarding/Field/FieldOrder.vue")
const PhoneUnsupported = () => import(/* webpackChunkName: "field" */ "@pages/Account/PhoneUnsupported.vue")
const FieldChargingPoint = () => import(/* webpackChunkName: "field" */ "@pages/Onboarding/Field/FieldChargingPoint.vue")

// Pending CDR & Validation
const PendingCdrList = () => import(/* webpackChunkName: "pending-cdr" */ "@pages/PendingCdr/PendingCdrList.vue")
const PendingCdrCorrection = () => import(/* webpackChunkName: "pending-cdr" */ "@pages/PendingCdr/PendingCdrCorrection.vue")

// Export module
const ExportLayout = () => import(/* webpackChunkName: "export" */ "@pages/Export/ExportLayout.vue")
const ExportList = () => import(/* webpackChunkName: "export" */ "@pages/Export/ExportList.vue")
const ExportWizard = () => import(/* webpackChunkName: "export" */ "@pages/Export/ExportWizard.vue")
const ExportDetail = () => import(/* webpackChunkName: "export" */ "@pages/Export/ExportDetail.vue")
const ExportHistory = () => import(/* webpackChunkName: "export" */ "@pages/Export/ExportHistory.vue")
const FormulaHelp = () => import(/* webpackChunkName: "export" */ "@pages/Export/FormulaHelp.vue")
const ExportTemplateList = () => import(/* webpackChunkName: "export" */ "@pages/Export/Template/ExportTemplateList.vue")
const ExportTemplateWizard = () => import(/* webpackChunkName: "export" */ "@pages/Export/Template/ExportTemplateWizard.vue")
const ExportTemplateDetail = () => import(/* webpackChunkName: "export" */ "@pages/Export/Template/ExportTemplateDetail.vue")
const DestinationList = () => import(/* webpackChunkName: "export" */ "@pages/Export/Destination/DestinationList.vue")
const DestinationForm = () => import(/* webpackChunkName: "export" */ "@pages/Export/Destination/DestinationForm.vue")
const CdrDashboard = () => import(/* webpackChunkName: "cdr-validation" */ "@pages/CdrDashboard/CdrDashboard.vue")
const CdrDetail = () => import(/* webpackChunkName: "cdr-detail" */ "@pages/Cdr/CdrDetail.vue")
const TelematicsConsentForm = () => import(/* webpackChunkName: "vehicle" */ "@pages/Vehicle/TelematicsConsentForm.vue")
const PublicOnboarding = () => import(/* webpackChunkName: "payment-onboarding" */ "@pages/PaymentOnboarding/PublicOnboarding.vue")
const PublicPaymentAuthentication = () => import(/* webpackChunkName: "payment" */ "@pages/Payment/PublicPaymentAuthentication.vue")
const SsoInitiate = () => import(/* webpackChunkName: "sso" */ "@pages/Account/SsoInitiate.vue")
const SsoCallback = () => import(/* webpackChunkName: "sso" */ "@pages/Account/SsoCallback.vue")
const SsoTokenLogin = () => import(/* webpackChunkName: "sso" */ "@pages/Account/SsoTokenLogin.vue")
const MeterDeviceReadingForm = () => import(/* webpackChunkName: "meter-device-readings" */ "@pages/MeterDevice/MeterDeviceReadingForm.vue")
const MeterDeviceAdd = () => import(/* webpackChunkName: "price-index" */ "@pages/MeterDevice/MeterDeviceAdd.vue")
const MeterDeviceDetail = () => import(/* webpackChunkName: "price-index" */ "@pages/MeterDevice/MeterDeviceDetail.vue")
const MeterDeviceEdit = () => import(/* webpackChunkName: "price-index" */ "@pages/MeterDevice/Detail/MeterDeviceEdit.vue")
const MeterDeviceInformation = () => import(/* webpackChunkName: "price-index" */ "@pages/MeterDevice/Detail/MeterDeviceInformation.vue")
const MeterDeviceUsages = () => import(/* webpackChunkName: "price-index" */ "@pages/MeterDevice/Detail/MeterDeviceUsages.vue")
const MeterDeviceReadings = () => import(/* webpackChunkName: "price-index" */ "@pages/MeterDevice/Detail/MeterDeviceReadings.vue")
const ConnectedVehicleCharges = () => import(/* webpackChunkName: "price-index" */ "@pages/MeterDevice/Detail/ConnectedVehicleCharges.vue")
const VehicleMeterCharges = () => import(/* webpackChunkName: "price-index" */ "@pages/MeterDevice/Detail/VehicleMeterCharges.vue")
const MeterDeviceDetailLicences = () => import(/* webpackChunkName: "price-index" */ "@pages/MeterDevice/Detail/MeterDeviceDetailLicences.vue")

const SubscriptionAnomaly = () => import(/* webpackChunkName: "anomaly" */ "@pages/Anomaly/SubscriptionAnomaly.vue")
const ExpensePeriodBulkClosure = () => import(/* webpackChunkName: "expense" */ "@pages/ExpensePeriod/ExpensePeriodBulkClosure.vue")
const AuditTrail = () => import(/* webpackChunkName: "audit-trail" */ "@pages/Security/AuditTrail.vue")
const SettingsHome = () => import(/* webpackChunkName: "settings" */ "@pages/Settings/SettingsHome.vue")

const VatRateSearch = () => import(/* webpackChunkName: "vat-rate" */ "@pages/VatRate/VatRateSearch.vue")
const VatRateForm = () => import(/* webpackChunkName: "vat-rate" */ "@pages/VatRate/VatRateForm.vue")
const PublicApiTokenSearch = () => import(/* webpackChunkName: "public-api-token" */ "@pages/PublicApiToken/PublicApiTokenSearch.vue")
const PublicApiTokenForm = () => import(/* webpackChunkName: "public-api-token" */ "@pages/PublicApiToken/PublicApiTokenForm.vue")
const ReportFinancial = () => import(/* webpackChunkName: "financial" */ "@pages/Report/ReportFinancial.vue")
const BillingControlWorkspace = () => import(/* webpackChunkName: "billing-control" */ "@pages/Report/BillingControl/FinancialControlWorkspace.vue")
const BillingGapAnalysis = () => import(/* webpackChunkName: "billing-control" */ "@pages/Report/BillingControl/BillingGapAnalysis.vue")
const RevenueOpportunities = () => import(/* webpackChunkName: "billing-control" */ "@pages/Report/BillingControl/RevenueOpportunities.vue")
const RevenueCutoff = () => import(/* webpackChunkName: "billing-control" */ "@pages/Report/BillingControl/RevenueCutoff.vue")
const TokenDetail = () => import(/* webpackChunkName: "price-index" */ "@pages/Token/TokenDetail.vue")
const TokenDetailInformation = () => import(/* webpackChunkName: "price-index" */ "@pages/Token/Detail/TokenInformation.vue")
const TokenDetailEdit = () => import(/* webpackChunkName: "price-index" */ "@pages/Token/Detail/TokenEdit.vue")
const TokenDetailUsages = () => import(/* webpackChunkName: "price-index" */ "@pages/Token/Detail/TokenUsages.vue")
const TokenSessionAuthorizations = () => import(/* webpackChunkName: "price-index" */ "@pages/Token/Detail/TokenSessionAuthorizations.vue")

const Invoices = () => import(/* webpackChunkName: "financial" */ "@pages/Invoice/Invoices.vue")
const ProformaInvoices = () => import(/* webpackChunkName: "financial" */ "@pages/ProformaInvoice/ProformaInvoices.vue")
const ProformaInvoiceEdit = () => import(/* webpackChunkName: "financial" */ "@pages/ProformaInvoice/ProformaInvoiceEdit.vue")
const ProformaInvoicesByRecipient = () => import(/* webpackChunkName: "financial" */ "@pages/ProformaInvoice/ProformaInvoicesByRecipient.vue")
const ConversionTaskList = () => import(/* webpackChunkName: "financial" */ "@pages/ProformaInvoice/ConversionTaskList.vue")
const ConversionTaskDetail = () => import(/* webpackChunkName: "financial" */ "@pages/ProformaInvoice/ConversionTaskDetail.vue")
const SuspiciousIpsList = () => import(/* webpackChunkName: "security" */ "@pages/Security/SuspiciousIpsList.vue")
const BillingRequests = () => import(/* webpackChunkName: "financial" */ "@pages/BillingRequest/BillingRequests.vue")
const BillingRequestSearch = () => import(/* webpackChunkName: "financial" */ "@pages/BillingRequest/BillingRequestSearch.vue")
const BillingRequestPreInvoicing = () => import(/* webpackChunkName: "financial" */ "@pages/BillingRequest/BillingRequestPreInvoicing.vue")

const BillingRequestInvoices = () => import(/* webpackChunkName: "financial" */ "@pages/BillingRequest/BillingRequestInvoices.vue")
const BillingRequestInvoiceShow = () => import(/* webpackChunkName: "financial" */ "@pages/BillingRequest/BillingRequestInvoiceShow.vue")
const BillingRequestInvoiceEdit = () => import(/* webpackChunkName: "financial" */ "@pages/BillingRequest/BillingRequestInvoiceEdit.vue")

const Agreements = () => import(/* webpackChunkName: "financial" */ "@pages/Agreement/Agreements")
const AgreementForm = () => import(/* webpackChunkName: "financial" */ "@pages/Agreement/AgreementForm")
const MarginManager = () => import(/* webpackChunkName: "financial" */ "@pages/MarginManager/MarginManager")
const RegisterExternalInvoice = () => import(/* webpackChunkName: "financial" */ "@pages/MeterDevice/RegisterExternalInvoice.vue")
const MeterDeviceExternalOperatorStatements = () => import(/* webpackChunkName: "financial" */ "@pages/MeterDevice/Detail/MeterDeviceExternalOperatorStatements.vue")
const ReportMeterDeviceStatements = () => import(/* webpackChunkName: "financial" */ "@pages/Report/ReportMeterDeviceStatements.vue")
const JobManager = () => import(/* webpackChunkName: "job" */ "@pages/JobManager/JobManager.vue")
const JobManagerDashboard = () => import(/* webpackChunkName: "job" */ "@pages/JobManager/Details/Dashboard.vue")
const JobManagerSchedules = () => import(/* webpackChunkName: "job" */ "@pages/JobManager/Details/Schedules.vue")
const JobManagerFailedJobs = () => import(/* webpackChunkName: "job" */ "@pages/JobManager/Details/FailedJobs.vue")



import chargingPointRoutes from "./chargingPoint"
import customerRoutes from "./customer"
import locationRoutes from "./location"
import pdlRoutes from "./pdl"
import organisationRoutes from "./organisation"
import memberRoutes from "./member"
import vehicleRoutes from "./vehicle"
import SubscriptionPlanForm from "@pages/SubscriptionPlan/SubscriptionPlanForm.vue";
import operatorGroups from "@/router/operatorGroups";




Vue.use(VueRouter)


export default new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '',
      component: Default,
      children: [
        {
          path: '',
          redirect: '/dashboard',
          meta: {
            auth: true,
          }
        },
        {
          name: 'dashboard',
          path: 'dashboard',
          component: Dashboard,
          meta: {
            auth: true,
          },
        },
        {
          name: 'dashboard.organization',
          path: 'dashboard2',
          component: DashboardOrganization,
          meta: {
            auth: true,
          },
        },



        {
          name: 'operators',
          path: 'operators',
          component: Operators,
          meta: {
            auth: true,
          },
        },
        {
          name: 'operator',
          path: 'operators/:id',
          component: Operator,
          meta: {
            auth: true,
          },
        },
        {
          path: 'job-manager',
          component: JobManager,
          meta: {
            auth: true,
          },
          children: [
            {
              name: 'job-manager.dashboard',
              path: '',
              component: JobManagerDashboard,
              meta: {
                auth: true,
              },
            },
            {
              name: 'job-manager.jobs',
              path: 'jobs',
              component: () => import(/* webpackChunkName: "job" */ "@pages/JobManager/Details/Jobs.vue"),
              meta: {
                auth: true,
              },
            },
            {
              name: 'job-manager.schedules',
              path: 'schedules',
              component: JobManagerSchedules,
              meta: {
                auth: true,
              },
            },
            {
              name: 'job-manager.failed',
              path: 'failed',
              component: JobManagerFailedJobs,
              meta: {
                auth: true,
              },
            },
          ]
        },
        {
          name: 'reports',
          path: 'reports',
          component: Report,
          meta: {
            auth: true,
          },
        },

        {
          name: 'reports.usages',
          path: 'reports/usages',
          component: ReportUsages,
          meta: {
            auth: true,
          },
        },

        {
          name: 'reports.meter-device-statements',
          path: 'reports/meter-device-statements',
          component: ReportMeterDeviceStatements,
          meta: {
            auth: true,
          },
        },

        {
          name: 'reports.offline',
          path: 'reports/offline',
          component: ReportOffline,
          meta: {
            auth: true,
          },
        },

        {
          name: 'reports.exports',
          path: 'reports/exports',
          component: ReportExports,
          meta: {
            auth: true,
          },
        },

        {
          name: 'reports.financial',
          path: 'reports/financial',
          component: ReportFinancial,
          meta: {
            auth: true,
          },
        },

        {
          name: 'reports.billing-control',
          path: 'reports/billing-control',
          component: BillingControlWorkspace,
          meta: {
            auth: true,
          },
        },

        {
          name: 'reports.billing-gaps',
          path: 'reports/billing-gaps',
          component: BillingGapAnalysis,
          meta: {
            auth: true,
          },
        },

        {
          name: 'reports.revenue-opportunities',
          path: 'reports/revenue-opportunities',
          component: RevenueOpportunities,
          meta: {
            auth: true,
          },
        },

        {
          name: 'reports.revenue-cutoff',
          path: 'reports/revenue-cutoff',
          component: RevenueCutoff,
          meta: {
            auth: true,
          },
        },


        {
          name: 'reports.energy-provider',
          path: 'reports/energy-provider',
          component: ReportEnergyProvider,
          meta: {
            auth: true,
          },
        },

        {
          name: 'reports.mail-events',
          path: 'reports/mail-events',
          component: MailEventSearch,
          meta: {
            auth: true,
          },
        },

        {
          name: 'alerts',
          path: 'alerts',
          component: Alerts,
          meta: {
            auth: true,
          },
        },

        {
          name: 'issues',
          path: 'issues',
          component: Issues,
          meta: {
            auth: true,
          },
        },

        {
          name: 'issues.add',
          path: 'issues/add',
          component: IssueAdd,
          meta: {
            auth: true,
          },
        },

        {
          name: 'issues.detail',
          path: 'issues/:id',
          component: IssueDetail,
          meta: {
            auth: true,
          },
        },



        {
          name: 'subscription-plans',
          path: 'subscription-plans',
          component: SubscriptionPlanSearch,
          meta: {
            auth: true,
          },
        },

        {
          name: 'subscription-plans.add',
          path: 'subscription-plans/add',
          component: SubscriptionPlanForm,
          meta: {
            auth: true,
          },
        },

        {
          name: 'subscription-plans.edit',
          path: 'subscription-plans/edit/:id',
          component: SubscriptionPlanForm,
          meta: {
            auth: true,
          },
        },

        {
          name: 'token.search',
          path: 'tokens',
          component: TokenSearch,
          meta: {
            auth: true,
          },
        },
        {
          path: 'tokens/:id',
          component: TokenDetail,
          children: [
            {
              name: 'tokens.detail',
              path: '',
              component: TokenDetailInformation,
            },
            {
              name: 'tokens.edit',
              path: 'edit',
              component: TokenDetailEdit,
            },
            {
              name: 'tokens.usages',
              path: 'usages',
              component: TokenDetailUsages,
            },
            {
              name: 'tokens.authorizations',
              path: 'authorizations',
              component: TokenSessionAuthorizations,
            }
          ]
        },
        {
          name: 'electricity-index',
          path: 'electricity-index',
          component: ElectricityIndexSearch,
          meta: {
            auth: true,
          },
        },

        {
          name: 'electricity-index.add',
          path: 'electricity-index/add',
          component: ElectricityIndexForm,
          meta: {
            auth: true,
          },
        },

        {
          name: 'electricity-index.edit',
          path: 'electricity-index/edit/:id',
          component: ElectricityIndexForm,
          meta: {
            auth: true,
          },
        },

        {
          name: 'margin-manager',
          path: 'margin-manager',
          component: MarginManager,
          meta: {
            auth: true,
          },
        },

        {
          name: 'electricity-tariff',
          path: 'electricity-tariff/:electricityIndexId',
          component: ElectricityTariffSearch,
          meta: {
            auth: true,
          },
        },

        {
          name: 'electricity-tariff.edit',
          path: 'electricity-tariff/:electricityIndexId/edit/:id',
          component: ElectricityTariffForm,
          meta: {
            auth: true,
          },
        },

        {
          name: 'electricity-tariff.add',
          path: 'electricity-tariff/:electricityIndexId/add',
          component: ElectricityTariffForm,
          meta: {
            auth: true,
          },
        },
        {
          name: 'meter-device',
          path: 'meter-device',
          component: MeterDeviceSearch,
          meta: {
            auth: true,
          },
        },

        {
          name: 'meter-device.add',
          path: 'meter-device/add',
          component: MeterDeviceAdd,
          meta: {
            auth: true,
          },
        },
        {
          name: 'meter-device.import-cdrs',
          path: 'meter-device/import-cdrs',
          component: ImportMeterDeviceCdr,
          meta: {
            auth: true,
          },
        },
        {
          path: 'meter-device/:id',
          component: MeterDeviceDetail,
          meta: {
            auth: true,
          },
          children: [
            {
              path: '',
              name: 'meter-device.detail',
              component: MeterDeviceInformation,
            },
            {
              path: 'edit',
              name: 'meter-device.edit',
              component: MeterDeviceEdit,
            },
            {
              path: 'usages',
              name: 'meter-device.usages',
              component: MeterDeviceUsages,
            },
            {
              path: 'readings',
              name: 'meter-device.readings',
              component: MeterDeviceReadings,
            },


            {
              path: 'external-operator/statements',
              name: 'meter-device.external-operator.statements',
              component: MeterDeviceExternalOperatorStatements,
            },

            {
              path: 'connected-vehicle-charges',
              name: 'meter-device.connected-vehicle-charges',
              component: VehicleMeterCharges,
            },
            {
              path: 'connected-vehicle-analysis',
              name: 'meter-device.connected-vehicle-analysis',
              component: ConnectedVehicleCharges,
            },
            {
              path: 'licences',
              name: 'meter-device.licences',
              component: MeterDeviceDetailLicences,
            },
          ],
        },

        {
          name: 'price-index',
          path: 'price-index',
          component: PriceIndexSearch,
          meta: {
            auth: true,
          },
        },

        {
          name: 'organization-perimeter',
          path: 'organization/perimeter',
          component: OrganizationPerimeterSearch,
          meta: { auth: true },
        },
        {
          name: 'organization-perimeter.add',
          path: 'organization/perimeter/add',
          component: OrganizationPerimeterForm,
          meta: { auth: true },
        },
        {
          name: 'organization-perimeter.edit',
          path: 'organization/perimeter/edit/:id',
          component: OrganizationPerimeterForm,
          meta: { auth: true },
        },
        {
          name: 'organization-sub-perimeter',
          path: 'organization/sub-perimeter',
          component: OrganizationSubPerimeterSearch,
          meta: { auth: true },
        },
        {
          name: 'organization-sub-perimeter.add',
          path: 'organization/sub-perimeter/add',
          component: OrganizationSubPerimeterForm,
          meta: { auth: true },
        },
        {
          name: 'organization-sub-perimeter.edit',
          path: 'organization/sub-perimeter/edit/:id',
          component: OrganizationSubPerimeterForm,
          meta: { auth: true },
        },

        {
          name: 'price-index.add',
          path: 'price-index/add',
          component: PriceIndexForm,
          meta: {
            auth: true,
          },
        },

        {
          name: 'price-index.edit',
          path: 'price-index/edit/:id',
          component: PriceIndexForm,
          meta: {
            auth: true,
          },
        },

        {
          name: 'price-tariff',
          path: 'price-tariff/:priceIndexId',
          component: PriceTariffSearch,
          meta: {
            auth: true,
          },
        },
        {
          name: 'price-tariff.edit',
          path: 'price-tariff/:priceIndexId/edit/:id',
          component: PriceTariffForm,
          meta: {
            auth: true,
          },
        },

        {
          name: 'price-tariff.add',
          path: 'price-tariff/:priceIndexId/add',
          component: PriceTariffForm,
          meta: {
            auth: true,
          },
        },
        {
          name: 'user.search',
          path: 'users',
          component: UserSearch,
          meta: {
            auth: true,
          },
        },
        {
          name: 'user.add',
          path: 'users/add',
          component: UserForm,
          meta: {
            auth: true,
          },
        },
        {
          name: 'user.edit',
          path: 'users/:id',
          component: UserForm,
          meta: {
            auth: true,
          },
        },
        // Anciennes adresses des gestionnaires (/user), gardées pour les favoris.
        {
          path: 'user',
          redirect: {name: 'user.search'},
        },
        {
          path: 'user/add',
          redirect: to => ({name: 'user.add', query: to.query}),
        },
        {
          path: 'user/:id',
          redirect: to => ({name: 'user.edit', params: to.params}),
        },
        {
          name: 'security.suspicious-ips',
          path: 'security/suspicious-ips',
          component: SuspiciousIpsList,
          meta: {
            auth: true,
          },
        },

        {
          name: 'my-account',
          path: 'account',
          component: AccountForm,
          meta: {
            auth: true,
          },
        },

        {
          name: 'manage-tariffs',
          path: 'manage-tariffs',
          component: ManageTariffs,
          meta: {
            auth: true,
          },
        },

        {
          name: 'gireve.import-tariffs',
          path: 'gireve/import-tariffs',
          component: ImportTariffs,
          meta: {
            auth: true,
          },
        },

        {
          name: 'audit-trail',
          path: 'audit-trail',
          component: AuditTrail,
          meta: {
            auth: true,
          },
        },

        {
          name: 'settings',
          path: 'settings',
          component: SettingsHome,
          meta: {
            auth: true,
          },
        },

        {
          name: 'anomaly.subscription',
          path: 'anomaly/subscription',
          component: SubscriptionAnomaly,
          meta: {
            auth: true,
          },
        },

        {
          name: 'expense-periods.bulk-closure',
          path: 'expense-periods/bulk-closure',
          component: ExpensePeriodBulkClosure,
          meta: {
            auth: true,
          },
        },

        {
          name: 'vat-rates',
          path: 'vat-rates',
          component: VatRateSearch,
          meta: {
            auth: true,
          },
        },

        {
          name: 'vat-rates.add',
          path: 'vat-rates/add',
          component: VatRateForm,
          meta: {
            auth: true,
          },
        },

        {
          name: 'vat-rates.edit',
          path: 'vat-rates/edit/:id',
          component: VatRateForm,
          meta: {
            auth: true,
          },
        },

        {
          name: 'public-api-tokens',
          path: 'settings/public-api-tokens',
          component: PublicApiTokenSearch,
          meta: {
            auth: true,
          },
        },

        {
          name: 'public-api-tokens.add',
          path: 'settings/public-api-tokens/add',
          component: PublicApiTokenForm,
          meta: {
            auth: true,
          },
        },

        {
          name: 'public-api-tokens.edit',
          path: 'settings/public-api-tokens/edit/:id',
          component: PublicApiTokenForm,
          meta: {
            auth: true,
          },
        },

        {
          name: 'invoices',
          path: 'invoices/:recipientType?',
          component: Invoices,
          meta: {
            auth: true,
          },
        },

        {
          name: 'proforma-invoices',
          path: 'proforma-invoices/:recipientType?',
          component: ProformaInvoices,
          meta: {
            auth: true,
          },
        },

        {
          name: 'proforma-invoices.edit',
          path: 'proforma-invoices/edit/:id',
          component: ProformaInvoiceEdit,
          meta: {
            auth: true,
          },
        },

        {
          name: 'proforma-invoices-by-recipient',
          path: 'proforma-invoices/by-recipient',
          component: ProformaInvoicesByRecipient,
          meta: {
            auth: true,
          },
        },

        {
          name: 'proforma-invoice-conversion-task.list',
          path: 'proforma-invoice-conversion-tasks',
          component: ConversionTaskList,
          meta: {
            auth: true,
          },
        },

        {
          name: 'proforma-invoice-conversion-task.detail',
          path: 'proforma-invoice-conversion-tasks/:id',
          component: ConversionTaskDetail,
          meta: {
            auth: true,
          },
        },

        {
          path: 'billing-requests',
          component: BillingRequests,
          meta: {
            auth: true,
          },
            children: [
                {
                    name: 'billing-requests',
                    path: '',
                    component: BillingRequestSearch,
                    meta: {
                        auth: true,
                    },
                },

                {
                    name: 'billing-requests.pre-invoicing',
                    path: 'pre-invoicing',
                    component: BillingRequestPreInvoicing,
                    meta: {
                        auth: true,
                    },
                },


                {
                    name: 'billing-requests.invoices',
                    path: 'invoices',
                    component: BillingRequestInvoices,
                    meta: {
                        auth: true,
                    },
                },
            ]
        },



        {
          name: 'billing-requests.invoices.show',
          path: 'billing-requests/invoices/show/:id',
          component: BillingRequestInvoiceShow,
          meta: {
            auth: true,
          },
        },

        {
          name: 'billing-requests.invoices.edit',
          path: 'billing-requests/invoices/edit/:id',
          component: BillingRequestInvoiceEdit,
          meta: {
            auth: true,
          },
        },

        {
          name: 'agreements',
          path: 'agreements',
          component: Agreements,
          meta: {
            auth: true,
          },
        },

        {
          name: 'agreements.add',
          path: 'agreements/add',
          component: AgreementForm,
          meta: {
            auth: true,
          },
        },

        {
          name: 'agreements.edit',
          path: 'agreements/edit/:id',
          component: AgreementForm,
          meta: {
            auth: true,
          },
        },







        // Payment Onboarding (Back-office)
        {
          name: 'onboarding.registrations',
          path: 'onboarding/registrations',
          component: RegistrationList,
          meta: {
            auth: true,
          },
        },
        {
          name: 'onboarding.registrations.detail',
          path: 'onboarding/registrations/:id',
          component: RegistrationDetail,
          meta: {
            auth: true,
          },
        },
        {
          name: 'onboarding.commissionings',
          path: 'onboarding/commissionings',
          component: CommissioningList,
          meta: {
            auth: true,
          },
        },
        {
          name: 'onboarding.consent-withdrawals',
          path: 'onboarding/consent-withdrawals',
          component: ConsentWithdrawals,
          meta: {
            auth: true,
          },
        },
        // Firmware (ZEborne seul) : les constructeurs et leurs firmwares, les mises à jour, les diagnostics.
        {
          name: 'firmware',
          path: 'firmware',
          component: FirmwarePage,
          meta: {
            auth: true,
          },
        },
        // Mettre à jour des bornes choisies (la sélection arrive en paramètre, pas dans l'adresse).
        {
          name: 'firmware.launch',
          path: 'firmware/launch',
          component: FirmwareLaunch,
          props: true,
          meta: {
            auth: true,
          },
        },
        // La fiche d'un constructeur, pour toute la plateforme (le firmware n'en est qu'un onglet).
        {
          name: 'manufacturers',
          path: 'manufacturers',
          component: ManufacturersPage,
          meta: {
            auth: true,
          },
        },
        {
          path: 'manufacturers/:id',
          component: ManufacturerSheet,
          props: true,
          meta: {
            auth: true,
          },
          children: [
            {
              name: 'manufacturer',
              path: '',
              component: ManufacturerProductLines,
              props: route => ({manufacturerId: route.params.id}),
            },
            {
              name: 'manufacturer.firmware',
              path: 'firmware',
              component: ManufacturerFirmware,
            },
            {
              name: 'manufacturer.configuration',
              path: 'configuration',
              component: TrackedKeys,
              props: route => ({manufacturerId: route.params.id}),
            },
            {
              name: 'manufacturer.settings',
              path: 'settings',
              component: ManufacturerSettings,
            },
            {
              name: 'manufacturer.history',
              path: 'history',
              component: ManufacturerHistory,
            },
          ],
        },
        // Ancienne adresse de la fiche.
        {
          name: 'firmware.manufacturer',
          path: 'firmware/manufacturers/:id',
          redirect: to => ({name: 'manufacturer', params: to.params}),
        },
        // Un nouveau firmware se crée toujours dans son constructeur.
        {
          name: 'firmware.new',
          path: 'manufacturers/:manufacturerId/firmwares/new',
          component: FirmwareEdit,
          props: true,
          meta: {
            auth: true,
          },
        },
        // Ancienne adresse de la création d'un firmware.
        {
          path: 'firmware/manufacturers/:manufacturerId/firmwares/new',
          redirect: to => ({name: 'firmware.new', params: to.params}),
        },
        {
          name: 'firmware.edit',
          path: 'firmware/firmwares/:id',
          component: FirmwareEdit,
          props: true,
          meta: {
            auth: true,
          },
        },
        // Le stock de badges (ZEborne seul) : référentiel, lots reçus, badges.
        {
          name: 'badge-inventory',
          path: 'badge-inventory',
          component: BadgeInventory,
          meta: {
            auth: true,
          },
        },
        // Les envois de badges sont une file des commandes en attente.
        {
          name: 'onboarding.badge-shipments',
          path: 'onboarding/badge-shipments',
          redirect: { name: 'onboarding.commissionings', query: { queue: 'shipment' } },
        },
        {
          name: 'onboarding.badge-shipments.preparation',
          path: 'onboarding/badge-shipments/:id',
          component: BadgeShipmentPreparation,
          meta: {
            auth: true,
          },
        },
        {
          name: 'onboarding.commissionings.detail',
          path: 'onboarding/commissionings/:id',
          component: CommissioningDetail,
          meta: {
            auth: true,
          },
        },
        {
          name: 'payment-onboarding.enrollments',
          path: 'payment-onboarding/enrollments',
          component: EnrollmentList,
          meta: {
            auth: true,
          },
        },
        {
          name: 'payment-onboarding.enrollments.new',
          path: 'payment-onboarding/enrollments/new',
          component: EnrollmentNew,
          meta: {
            auth: true,
          },
        },
        {
          name: 'payment-onboarding.import',
          path: 'payment-onboarding/import',
          component: EnrollmentImport,
          meta: {
            auth: true,
          },
        },

        // CDR Dashboard (Consolidated)
        {
          name: 'cdr-dashboard',
          path: 'dashboard/cdr',
          component: CdrDashboard,
          meta: {
            auth: true,
          },
        },

        // CDR Detail (Universal view)
        {
          name: 'cdr-detail',
          path: 'cdr/:id',
          component: CdrDetail,
          meta: {
            auth: true,
          },
        },

        // Pending CDR Correction (dedicated page)
        {
          name: 'pending-cdrs.correction',
          path: 'cdrs/pending-review/:id',
          component: PendingCdrCorrection,
          meta: {
            auth: true,
          },
        },

        // Export module — parent layout with shared tabs (Exports / Formats / Destinataires / Historique)
        {
          path: 'exports',
          component: ExportLayout,
          meta: { auth: true },
          children: [
            { name: 'exports.list', path: '', component: ExportList, meta: { auth: true } },
            { name: 'exports.templates.list', path: 'templates', component: ExportTemplateList, meta: { auth: true } },
            { name: 'exports.destinations.list', path: 'destinations', component: DestinationList, meta: { auth: true } },
            { name: 'exports.history', path: 'history', component: ExportHistory, meta: { auth: true } },
          ],
        },
        // Full-screen pages (no shared tabs)
        { name: 'exports.formula-help', path: 'exports/aide/formules', component: FormulaHelp, meta: { auth: true } },
        { name: 'exports.create', path: 'exports/new', component: ExportWizard, meta: { auth: true } },
        { name: 'exports.templates.create', path: 'exports/templates/new', component: ExportTemplateWizard, meta: { auth: true } },
        { name: 'exports.templates.edit', path: 'exports/templates/:id/edit', component: ExportTemplateWizard, meta: { auth: true } },
        { name: 'exports.templates.detail', path: 'exports/templates/:id', component: ExportTemplateDetail, meta: { auth: true } },
        { name: 'exports.destinations.create', path: 'exports/destinations/new', component: DestinationForm, meta: { auth: true } },
        { name: 'exports.destinations.edit', path: 'exports/destinations/:id/edit', component: DestinationForm, meta: { auth: true } },
        { name: 'exports.edit', path: 'exports/:id/edit', component: ExportWizard, meta: { auth: true } },
        { name: 'exports.detail', path: 'exports/:id', component: ExportDetail, meta: { auth: true } },

        // Legacy routes - redirect to new consolidated dashboard
        {
          path: 'cdrs/pending-review',
          redirect: { name: 'cdr-dashboard', query: { tab: 'pending' } },
        },
        {
          path: 'cdrs/validation/dashboard',
          redirect: { name: 'cdr-dashboard' },
        },
        {
          path: 'cdrs/validation/logs',
          redirect: { name: 'cdr-dashboard', query: { tab: 'history' } },
        },

        ...organisationRoutes,
        ...memberRoutes,
        ...locationRoutes,
        ...pdlRoutes,
        ...chargingPointRoutes,
        ...customerRoutes,
        ...vehicleRoutes,
        ...operatorGroups,

      ]
    },

    // Le portail terrain : une mise en page à part, sans menu, pour le technicien sur son téléphone.
    {
      path: '/field',
      component: Field,
      children: [
        {
          name: 'field',
          path: '',
          component: FieldPortal,
          meta: { auth: true },
        },
        {
          name: 'field.order',
          path: 'orders/:id',
          component: FieldOrder,
          meta: { auth: true },
        },
        {
          name: 'field.charging-point',
          path: 'charging-points/:id',
          component: FieldChargingPoint,
          meta: { auth: true },
        },
      ],
    },

    {
      path: '',
      component: Light,
      children: [
        {
          name: 'login',
          path: 'login',
          component: Login,
          meta: {
            auth: false,
          },
        },
        {
          name: 'phone-unsupported',
          path: 'phone-unsupported',
          component: PhoneUnsupported,
          meta: { auth: true },
        },
        {
          name: 'forgot-password',
          path: 'forgot-password',
          component: ForgotPassword,
        },
        {
          name: 'change-password',
          path: 'change-password',
          component: ChangePassword,
        },
        {
          name: 'activation',
          path: 'activation',
          component: Activation,
        },

        {
            name: 'member.register-iban',
            path: 'member/iban/update/:token',
            component: MemberRegisterIban,
        },

        {
          name: 'member.invitation',
          path: 'member/invitation/:token',
          component: MemberInvitation,
        },

        {
          name: 'meter-devices-reading.edit',
          path: 'meter-devices-readings/:token',
          component: MeterDeviceReadingForm,
        },

        {
          name: 'meter-devices.register-external-invoice',
          path: 'register-external-invoice',
          component: RegisterExternalInvoice,
        },

        // Payment Onboarding (Public)
        {
          name: 'onboarding',
          path: 'onboarding',
          component: PublicOnboarding,
        },

        // Lien d'invitation d'une organisation (public) : la page, puis la confirmation depuis l'e-mail.
        // La confirmation est déclarée avant le jeton, sinon « confirm » serait pris pour un jeton.
        {
          name: 'onboarding.join.confirm',
          path: 'onboarding/join/confirm',
          component: JoinConfirm,
        },
        {
          name: 'onboarding.join',
          path: 'onboarding/join/:token',
          component: JoinByLink,
        },

        // Tunnel du nouveau module d'onboarding (public, ouvert par le jeton du lien)
        {
          name: 'onboarding.tunnel',
          path: 'onboarding/tunnel',
          component: RegistrationTunnel,
        },

        // Public Payment Authentication (after 3D Secure / External redirect)
        {
          name: 'payment.auth',
          path: 'payment/return',
          component: PublicPaymentAuthentication,
        },

        // Telematics consent (Public, tokenised — no login)
        {
          name: 'telematics.consent',
          path: 'telematics-consent',
          component: TelematicsConsentForm,
        },

        // SSO
        {
          name: 'sso.callback',
          path: 'sso/callback',
          component: SsoCallback,
        },
        {
          name: 'sso.token',
          path: 'sso/token/:slug',
          component: SsoTokenLogin,
        },
        {
          name: 'sso.initiate',
          path: 'sso/:slug',
          component: SsoInitiate,
        },

      ]
    },



  ]
})
